import { render, staticRenderFns } from "./InstallBar.vue?vue&type=template&id=1f183cf4&scoped=true&"
import script from "./InstallBar.vue?vue&type=script&lang=js&"
export * from "./InstallBar.vue?vue&type=script&lang=js&"
import style0 from "./InstallBar.vue?vue&type=style&index=0&id=1f183cf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f183cf4",
  null
  
)

component.options.__file = "InstallBar.vue"
export default component.exports